import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41858fd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-text" }
const _hoisted_2 = { class: "name-text" }
const _hoisted_3 = {
  key: 0,
  class: "warning-message"
}
const _hoisted_4 = { class: "warning-message__inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "warning-message__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-exclamation" })
], -1))
const _hoisted_6 = { class: "warning-message__text" }
const _hoisted_7 = {
  key: 1,
  class: "text-align--center"
}
const _hoisted_8 = {
  key: 2,
  class: "list-style--none pl-0 text-align--center"
}
const _hoisted_9 = ["aria-setsize", "aria-posinset"]
const _hoisted_10 = {
  key: 3,
  class: "note-message"
}
const _hoisted_11 = {
  key: 0,
  id: "modal-confirmation",
  class: "row align-items-center justify-content-center"
}
const _hoisted_12 = { class: "col-auto" }
const _hoisted_13 = { class: "row align-items-center justify-content-center text-align--center" }
const _hoisted_14 = { class: "col-auto mt-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "col-auto mt-3"
}
const _hoisted_17 = {
  key: 1,
  class: "col-auto mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _ctx.negativeClicked,
    showClose: _ctx.showClose,
    "aria-modal": "true",
    role: "dialog"
  }, {
    modalHeader: _withCtx(() => [
      _createElementVNode("h2", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1)
      ])
    ]),
    modalBody: _withCtx(() => [
      (_ctx.warningMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.warningMessage), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.messages && _ctx.messages.length === 1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.messages[0]), 1))
        : _createCommentVNode("", true),
      (_ctx.messages && _ctx.messages.length > 1)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                "aria-setsize": _ctx.messages.length,
                "aria-posinset": index + 1
              }, _toDisplayString(message), 9, _hoisted_9))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.noteMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.noteMessage), 1))
        : _createCommentVNode("", true)
    ]),
    modalFooter: _withCtx(() => [
      (_ctx.showConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_checkbox, {
                label: _ctx.showConfirm,
                modelValue: _ctx.isConfirmed,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isConfirmed) = $event))
              }, null, 8, ["label", "modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["button button--shadow", [_ctx.positiveButtonColor ? 'button--' + _ctx.positiveButtonColor : '']]),
            id: "modal-positive-button",
            "data-test": "button-alertModalButtonPositive",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.positiveClicked && _ctx.positiveClicked(...args))),
            disabled: (_ctx.showConfirm && !_ctx.isConfirmed) || undefined
          }, _toDisplayString(_ctx.positiveButtonText), 11, _hoisted_15)
        ]),
        (_ctx.neutralButtonText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: "button button--shadow button--secondary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.neutralClicked && _ctx.neutralClicked(...args)))
              }, _toDisplayString(_ctx.neutralButtonText), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideNegativeButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                "data-test": "button-alertModalButtonNegative",
                class: _normalizeClass(["button button--shadow", [_ctx.negativeButtonColor !== 'blue' ? 'button--' + _ctx.negativeButtonColor : '']]),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.negativeClicked && _ctx.negativeClicked(...args)))
              }, _toDisplayString(_ctx.negativeButtonText), 3)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onClose", "showClose"]))
}